/** Textos de data e hora em português simples, no fuso da profissional. */
import { MONTH_NAMES, WEEKDAY_NAMES, WEEKDAY_SHORT } from './defaults';
import { type LocalDate, diffDays, parseDate, parseTime, utcToZoned, weekdayOf } from './time';

/** "14:30" -> "14h30"; "09:00" -> "9h" */
export function formatHour(time: string): string {
  const minutes = parseTime(time);
  const h = Math.floor(minutes / 60);
  const m = minutes % 60;
  return m === 0 ? `${h}h` : `${h}h${String(m).padStart(2, '0')}`;
}

/** Hora local de um instante UTC: "14h30" */
export function formatHourOf(utc: string | number, timeZone: string): string {
  return formatHour(utcToZoned(utc, timeZone).time);
}

/** "terça, 14/10" */
export function formatDayShort(date: LocalDate): string {
  const { month, day } = parseDate(date);
  return `${WEEKDAY_NAMES[weekdayOf(date)]}, ${String(day).padStart(2, '0')}/${String(month).padStart(2, '0')}`;
}

/** "terça, 14 de outubro" */
export function formatDayLong(date: LocalDate): string {
  const { month, day } = parseDate(date);
  return `${WEEKDAY_NAMES[weekdayOf(date)]}, ${day} de ${MONTH_NAMES[month - 1]}`;
}

/** "14/10" */
export function formatDayMonth(date: LocalDate): string {
  const { month, day } = parseDate(date);
  return `${String(day).padStart(2, '0')}/${String(month).padStart(2, '0')}`;
}

/** "ter 14" */
export function formatWeekdayNumber(date: LocalDate): { weekday: string; day: number } {
  return { weekday: WEEKDAY_SHORT[weekdayOf(date)] ?? '', day: parseDate(date).day };
}

/** "Hoje", "Amanhã", "Ontem" ou "terça, 14/10" */
export function relativeDayLabel(date: LocalDate, today: LocalDate): string {
  const d = diffDays(today, date);
  if (d === 0) return 'Hoje';
  if (d === 1) return 'Amanhã';
  if (d === -1) return 'Ontem';
  return formatDayShort(date);
}

/** Para mensagem: "hoje", "amanhã" ou "terça, 14/10" */
export function messageDayLabel(date: LocalDate, today: LocalDate): string {
  const d = diffDays(today, date);
  if (d === 0) return 'hoje';
  if (d === 1) return 'amanhã';
  return formatDayShort(date);
}

export function monthLabel(date: LocalDate): string {
  const { year, month } = parseDate(date);
  return `${MONTH_NAMES[month - 1]} de ${year}`;
}

export function formatDuration(min: number): string {
  if (min < 60) return `${min} min`;
  const h = Math.floor(min / 60);
  const m = min % 60;
  return m === 0 ? `${h}h` : `${h}h${String(m).padStart(2, '0')}`;
}

